import moment from 'moment';
import * as React from 'react';
import { getDisplayName } from '../../../../models/NameUtils';
import { useContact } from '../../../../queries/Contact/useContact';
import { CustomAudioPlayer } from '../../CustomAudioPlayer';
import type { RecordingPlaybackSurface } from '../../../services/recordingPlayback';

interface IProps {
	autoplay: boolean;
	contactId: string;
	creationDate: string;
	creatorName: string;
	phoneCallId: string;
	phoneNumber: string;
	recordingSource: string;
	surface: RecordingPlaybackSurface;
}

export const CallDetailsAudioPlayer: React.FC<IProps> = ({
	autoplay = false,
	contactId,
	creationDate,
	creatorName,
	phoneCallId,
	phoneNumber,
	recordingSource,
	surface,
}) => {
	// A rep may not be allowed to see the contact, so a failed lookup quietly falls back to the dialed number.
	const { data: contact, isLoading } = useContact({ contactId, enabled: !!contactId, retry: false });

	const title = `Call Recording (${moment(creationDate).format('M/DD/YYYY [at] h:mma')})`;
	const subtitle = contact
		? `${creatorName} called ${getDisplayName(contact)}`
		: isLoading
			? '...'
			: `${creatorName} called ${phoneNumber}`;

	return (
		<CustomAudioPlayer
			autoplay={autoplay}
			phoneCallId={phoneCallId}
			source={recordingSource}
			subtitle={subtitle}
			surface={surface}
			title={title}
		/>
	);
};
